import React from "react";
import { SubHeading } from "../../components";

import { images } from "../../constants";

import "./Header.css";

const Header = () => {
  return (
    <div className="app__header app__wrapper section__padding" id="#home">
      <div className="app__wrapper_info">
        <SubHeading title="Chase the new flavour" />
        <h1 className="app__header-h1">The Key to Good Food</h1>
        <p className="p__opensans" style={{ margin: "2rem 0" }}>
          POY specializes in delicious food featuring fresh ingredients and
          masterful preparation by the amazing Tahiya Islam. Whether you're
          ordering a multi-course meal or grabbing a drink and pizza at the bar,
          POY's lively, casual yet upscale atmosphere makes it perfect for
          dining with friends, family, clients and business associates.
        </p>
        <button type="button" className="custom__button">
          Explore Menu
        </button>
      </div>

      <div className="app__wrapper_img">
        <img src={images.welcome} alt="header" />
      </div>
    </div>
  );
};

export default Header;
